import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AmountFormatModule, StaticMsgModule, StaticMsgPipe } from '@lib/pipes';
import { ButtonModule, TextTooltipModule } from '@lib/components';
import { DialogDisplayServiceModule } from '@lib/services';
import { TooltipDirectiveModule } from '@lib/directives';
import { BaggageRequestComponent } from './baggage-request.component';
import { BaggageCatalogeComponent } from './baggage-cataloge/baggage-cataloge.component';
import { PassengerNameModule } from '@common/pipes';

@NgModule({
  declarations: [BaggageRequestComponent, BaggageCatalogeComponent],
  providers: [StaticMsgPipe],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    StaticMsgModule,
    DialogDisplayServiceModule,
    ButtonModule,
    TextTooltipModule,
    AmountFormatModule,
    TooltipDirectiveModule,
    PassengerNameModule,
  ],
  exports: [BaggageRequestComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class BaggageRequestModule {}
